<script>
	import httpService from '@/core/api/request'
	export default {
		data: function() {
			return {}
		},
		filters: {
			optionStatus: function (id) {
				return id == 1 ? 'Activo' : 'Inactivo'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/free_shipping/mixins.vue